/**
 * Coordinates Regios DOPP with the theme's variant-radios + section fetch flow:
 * 1. Before the theme replaces [data-variant-based] markup, add regios-dopp-generic-skip
 *    on the main PDP price container so the app does not run during the swap.
 * 2. After the theme fires product-variant-update, remove the class and dispatch
 *    regios-dopp:variant-change for the app to refresh prices.
 */
(function () {
  'use strict';

  var SKIP_CLASS = 'regios-dopp-generic-skip';
  var BRIDGE_EVENT = 'regios-dopp:variant-change';

  function getPriceContainers() {
    return document.querySelectorAll('#product-form .product-price');
  }

  function addSkipClass() {
    getPriceContainers().forEach(function (el) {
      el.classList.add(SKIP_CLASS);
    });
  }

  function removeSkipClass() {
    getPriceContainers().forEach(function (el) {
      el.classList.remove(SKIP_CLASS);
    });
  }

  function getQuantity() {
    return 1;
    // Uncomment if you want the discount to be calculated based on the quantity
    // input's value:
    // var input = document.querySelector('#product-form input[name="quantity"]');
    // if (!input) return 1;
    // var n = parseInt(input.value, 10);
    // return isNaN(n) || n < 1 ? 1 : n;
  }

  function dispatchRegiosVariantChange() {
    var page = window.RegiosDOPP_ProductPage;
    var variants = page && page.variants;
    if (!variants || !variants.length) return;

    var idInput = document.querySelector('#product-form input[name="id"]');
    if (!idInput) return;

    var variantId = parseInt(idInput.value, 10);
    if (isNaN(variantId)) return;

    var selectedVariant = variants.find(function (v) {
      return v.id === variantId;
    });
    if (!selectedVariant) return;

    window.dispatchEvent(
      new CustomEvent(BRIDGE_EVENT, {
        detail: {
          selectedVariant: selectedVariant,
          quantity: getQuantity(),
        },
      })
    );
  }

  /**
   * Capture phase: runs before variant-radios' change handler starts the section fetch.
   */
  function onChangeCapture(ev) {
    var radios = ev.target && ev.target.closest && ev.target.closest('variant-radios');
    if (!radios || !radios.closest('#product-form')) return;
    addSkipClass();
  }

  function onProductVariantUpdate() {
    removeSkipClass();
    dispatchRegiosVariantChange();
  }

  function init() {
    if (!document.querySelector('#product-form variant-radios')) return;
    document.addEventListener('change', onChangeCapture, true);
    document.addEventListener('product-variant-update', onProductVariantUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
